<template>
  <b-navbar toggleable="lg"
            :sticky="true"
            class="container-fluid main-background">
    <b-navbar-brand href="#"
                    v-scroll-to="'#app'">
      <img src="../../assets/img/corporate_logo.svg" alt="АдминСОФТ ПЛЮС" class="img-fluid">
    </b-navbar-brand>
    <a href="https://apro.adminplus.bg/AdminSoft-Support.exe"
       download="AdminSoft-Support.exe"
       class="display-lg-hidden ml-auto">
      <img src="../../assets/img/team-viewer.svg" alt="Отдалечена поддръжка" class="team-viewer-bgn">
    </a>
    <a href="https://platform.adminplus.bg/" class="btn btn-outline-warning ml-2 mr-4 display-lg-hidden">ВХОД</a>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto" v-b-scrollspy="105">
        <b-nav-item href="https://dogovori.adminplus.bg/"
                    class="mx-2"
                    target="_blank"
                    right><i class="text-uppercase"><strong>абониране</strong></i>
        </b-nav-item>
        <b-nav-item href="#modules"
                    class="mx-2"
                    v-scroll-to="'#modules'"
                    right><i>модули</i>
        </b-nav-item>
        <b-nav-item href="#platform"
                    class="mx-2"
                    v-scroll-to="'#platform'"
                    right><i>платформа</i>
        </b-nav-item>
        <b-nav-item href="#contacts"
                    class="mx-2"
                    v-scroll-to="'#contacts'"
                    id="contacts-link"
                    right><i>контакти</i>
          <b-tooltip target="contacts-link"
                     triggers="hover"
                     customClass="custom-tooltip"
                     placement="bottom">
            0889 846 651<br>contact@adminplus.bg
          </b-tooltip>
        </b-nav-item>
        <b-nav-item href="#gdpr"
                    class="mx-2"
                    v-scroll-to="'#gdpr'"
                    id="gdpr-link"
                    right><i>GDPR</i>
          <b-tooltip target="gdpr-link"
                     triggers="hover"
                     customClass="custom-tooltip"
                     placement="bottom">
            защита на<br>
            личните данни
          </b-tooltip>
        </b-nav-item>
<!--        <b-nav-item class="mx-2"-->
<!--                    :to="{name: 'guide'}"-->
<!--                    right><i>guide</i>-->
<!--        </b-nav-item>-->
        <li class="nav-item ml-5 display-hidden display-lg-inline-block"
            id="support-link">
          <a href="https://apro.adminplus.bg/AdminSoft-Support.exe"
             download="AdminSoft-Support.exe">
            <img src="../../assets/img/team-viewer.svg" alt="Отдалечена поддръжка" class="team-viewer-bgn">
            <b-tooltip target="support-link"
                       triggers="hover"
                       customClass="custom-tooltip"
                       placement="bottom">
              Отдалечена поддръжка
            </b-tooltip>
          </a>
        </li>
        <li class="nav-item ml-2 display-hidden display-lg-inline-block">
          <a href="https://platform.adminplus.bg/" class="btn btn-outline-warning">ВХОД</a>
        </li>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: "header-landing-component",
  data() {
    return {
      activeMenu: 'welcome'
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
